<div class="flag" [ngClass]="'flag-' + countryCode"></div>
